module.exports = __webpack_public_path__ + "afcd0ed48df6b1ce73a15b245e56b1f0.pdf";